import { Component, inject, OnInit, signal, WritableSignal, ChangeDetectionStrategy } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { ButtonComponent } from "../../../../shared/components/button/button.component";
import { DynamicDialogRef } from "@openng/optimus-ui/dynamicdialog";
import { MessageService } from "@openng/optimus-ui/api";
import { BotevoCoresService } from "../../../../services/api/botevo-cores/botevo-cores.service";
import { Core } from "../../../../models/api/tenant";
import { first } from "rxjs";
import { SelectModule } from "@openng/optimus-ui/select";

@Component({
  standalone: true,
  selector: "app-core-form",
  imports: [TranslateModule, ButtonComponent, SelectModule, ReactiveFormsModule],
  templateUrl: "./core-form.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./core-form.component.scss",
})
export class CoreFormComponent implements OnInit {
  public form = new FormGroup({
    coreId: new FormControl(null, Validators.required),
  });

  public translate = inject(TranslateService);
  private coreService = inject(BotevoCoresService);
  private message = inject(MessageService);

  private ref = inject(DynamicDialogRef);
  public coreOptions: WritableSignal<Core[]> = signal([]);

  ngOnInit() {
    this.coreService
      .getCores()
      .pipe(first())
      .subscribe({
        next: (cores) => {
          if (cores) {
            this.coreOptions.set(cores.filter((core) => !core.assigned));
          }
        },
      });
  }
  /**
   * Closes the dialog with the selected core's id if the form is valid.
   * If the form is invalid, shows an error message.
   */
  public save() {
    if (this.form.valid && this.form.value.coreId) {
      const coreId = this.form.value.coreId;
      this.ref.close(coreId);
    } else {
      this.message.add({
        key: "global",
        severity: "error",
        summary: this.translate.instant("common.error"),
        detail: this.translate.instant("common.invalid_form"),
        life: 4000,
      });
    }
  }

  /**
   * Closes the dialog and returns no value.
   */
  public closeDialog() {
    this.ref.close(null);
  }
}
